<template>
  <div>
    <el-drawer title="" :visible.sync="Editdrawer" :direction="direction">
      <template slot="title"
        ><h3 class="text-xl Add Products text-white">Templates</h3></template
      >
      <Drawer
        :Editdrawer="Editdrawer"
        @updateUiDrawer="updateDrawer"
        :editlanding="editlanding"
      />
    </el-drawer>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              class="flex"
              icon="ArrowLeftIcon"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Landing Page
          </h2>
        </div>
      </div>
    </div>
    <div class="bg-white menucontrol-scroll fixed-top p-8">
      <div class="flex justify-between items-center w-full">
        <div class="relative w-10/12">
          <el-input
            placeholder="Search"
            v-model="searchInput"
            class="w-full"
            v-on:input="searchDes"
          ></el-input>
          <div class="absolute top-0 mr-2 mt-2 bg-white cursor-pointer right-0">
            <feather-icon
              icon="SearchIcon"
              @click="getAll"
              SvgClasses="w-4 h-4"
            />
          </div>
        </div>
        <div class="w-2/12 flex justify-end">
          <vs-button
            @click="handleClick('marcom-landing-page-templates')"
            variant="primary"
            class="rounded-lg bg-primary border-0 text-white font-semibold lg:py-3 md:py-3 py-2 px-8 sm-fsize14"
          >
            Add Page
          </vs-button>
        </div>
      </div>

      <div class="w-full mt-8">
        <el-table
          :data="landingPageDetails"
          border
          style="width: 100%"
          class="table-responsive table-flush mt-6 cust-overflow-x-primary-color fsize12"
          header-row-class-name="thead-light table-th-color"
        >
          <el-table-column
            :index="indexmethod"
            type="index"
            label="Sr.no"
            width="80"
          ></el-table-column>
          <el-table-column prop="city" label="Page Name" min-width="100px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.pageName }}</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="Link" min-width="200px">
            <template v-slot="{ row }">
              <P
                class="text-primary cursor-pointer"
                @click="openLandingPage(row.fullURL)"
              >
                {{ row.fullURL }}
              </P>
            </template>
          </el-table-column>
          <el-table-column
            prop="city"
            label="No. of Recipients"
            min-width="100px"
          >
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.sends }}</P>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="No. of Opens" min-width="90px">
            <template v-slot="{ row }">
              <P class="text-gray">{{ row.clicks }}</P>
            </template>
          </el-table-column>

          <el-table-column min-width="70px" prop="date" label="Created date">
            <template v-slot="{ row }">
              <P class="text-gray">{{
                new Date(row.createdAt).toLocaleDateString()
              }}</P>
            </template>
          </el-table-column>

          <el-table-column prop="city" label="Actions" min-width="40px">
            <template v-slot="{ row }">
              <div class="flex gap-1 items-center">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="editlandingData(row)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-4 h-4"
                  class="cursor-pointer"
                  @click="deleteLanding(row._id)"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="w-full flex justify-end mt-6">
          <el-pagination
            @current-change="
              (value) => {
                currentPage = value;
                getAll();
              }
            "
            background
            layout="prev,pager,next"
            :total="landingData.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import "@/assets/scss/Index.scss";
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import Drawer from "./components/Drawer.vue";
export default {
  components: { FeatherIcon, Drawer },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      Editdrawer: false,
      activeName: "first",
      searchInput: "",
      editlanding: {},
      landingData: [],
    };
  },
  methods: {
    searchDes: _.debounce(function () {
      this.getAll();
    }, 500),

    updateDrawer(value) {
      this.Editdrawer = value;
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.$store.state.landingPage.editImage1 = false;
      this.$store.state.landingPage.editImage2 = false;
      this.$store.state.landingPage.editImage3 = false;
      this.$store.state.landingPage.editBannerImage = false;
    },

    openLandingPage(data) {
      window.open(data, "_blank");
    },
    async deleteLanding(id) {
      let payload = {
        _id: id,
      };
      await this.$store.dispatch("landingPage/deleteLandingPage", payload);
      this.getAll();
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    async getAll() {
      let payload = {
        searchInput: this.searchInput,
        paginated: true,
        limit: this.perPage,
      };
      if (this.currentPage == 1) {
        Object.assign(payload, { offset: this.perPage - 10 });
      } else {
        Object.assign(payload, {
          offset: this.perPage * (this.currentPage - 1),
        });
      }
      let { data } = await this.$store.dispatch(
        "landingPage/getAllLandingPage",
        payload
      );
      this.landingData = data;
    },
    async editlandingData(data) {
      this.Editdrawer = true;
      this.editlanding = data;
      console.log(data);
      this.$store.state.landingPage.templateName = data.type;
      this.$store.state.landingPage.editBannerImage = true;
      if (data.type == "temp2" || data.type == "temp4") {
        this.$store.state.landingPage.editImage1 = true;
        this.$store.state.landingPage.editImage2 = true;
        this.$store.state.landingPage.editImage3 = true;
      }
      if (data.type == "temp3") {
        this.$store.state.landingPage.editImage1 = true;
        this.$store.state.landingPage.editImage2 = true;
      }
    },
  },
  mounted() {
    this.getAll();
    console.log(this.landingPageDetails);
  },
  computed: {
    ...mapState("landingPage", ["landingPageDetails"]),
  },
};
</script>
